import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import './MobileContent.scss';
import MobileHomeDashboard from './MobileHomeDashboard';
import MobileRequestsList from './MobileRequestsList';
import MobileKai from './MobileKai/MobileKai';
import { MetricsPlot } from '../../Dashboard/DParser/types';
import { useDashboardChartDataQuery } from 'hooks/useDashboardChartDataQuery';
import { logger } from 'presentation/components/KSExport/reportNTParser/utils';
import { useLocationsStore } from 'hooks/useLocationsStore';
import { shallow } from 'zustand/shallow';
import { useAuthContext } from 'context/useAuthContext';

type Props = {
  activeTab: 'home' | 'requests' | 'kai';
  trace: boolean;
  onShowDetails?: (id: string) => void;
};

function MobileContent({ activeTab, trace, onShowDetails }: Props): JSX.Element {
  const [chartData, setChartData] = useState<MetricsPlot>({ periodReporting: true, periods: [], metrics: [] });
  const [readReport, setReadReport] = useState(false);
  // Reading chart data from BE
  const { data: chartBEData } = useDashboardChartDataQuery();

  useEffect(() => {
    if (chartBEData !== undefined) {
      if (!chartBEData?.metrics?.length) {
        setReadReport(true);
      } else {
        if (trace) logger.msg('chartData from BE ->', chartBEData);
        // @ts-ignore
        setChartData(chartBEData);
      }
    }
  }, [chartBEData]);

  return (
    <div className="MobileContent">
      {activeTab === 'home' && <MobileHomeDashboard chartData={chartData} readReport={readReport} trace={trace} />}

      {activeTab === 'requests' && (
        <MobileRequestsList readReport={readReport} trace={trace} onShowDetails={onShowDetails} />
      )}
      {activeTab === 'kai' && <MobileKai trace={trace} />}
    </div>
  );
}

export default MobileContent;
